"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconStarFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8.90619 1.5836C8.53829 0.822283 7.45365 0.823054 7.08681 1.58488L5.42106 5.04425L1.88592 5.51849C1.0866 5.62572 0.729119 6.58041 1.26154 7.18625L3.84216 10.1227L3.13944 13.7929C2.98525 14.5982 3.80424 15.242 4.55033 14.9019L7.99716 13.3308L11.4507 14.9022C12.1974 15.2419 13.0162 14.5968 12.8607 13.7914L12.1522 10.1227L14.7381 7.18713C15.2716 6.58152 14.9144 5.62579 14.1145 5.51848L10.5785 5.04413L8.90619 1.5836Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10.9048 1.58354C10.5369 0.822199 9.45224 0.823021 9.08542 1.58481L6.78342 6.36543L1.88552 7.02247C1.08616 7.1297 0.728741 8.08442 1.26115 8.69023L4.81385 12.7328L3.84498 17.7929C3.69079 18.5982 4.50975 19.242 5.25585 18.9019L9.99576 16.7414L14.7447 18.9022C15.4914 19.2419 16.3102 18.5968 16.1546 17.7914L15.1777 12.7327L18.738 8.69111C19.2715 8.08549 18.9142 7.12976 18.1144 7.02246L13.2156 6.3653L10.9048 1.58354Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12.9037 1.58354C12.5358 0.822228 11.4511 0.822991 11.0843 1.58481L8.14609 7.68665L1.88555 8.52649C1.08615 8.63373 0.728791 9.58847 1.26117 10.1943L5.78589 15.3428L4.55089 21.7929C4.39668 22.5983 5.21571 23.2419 5.96176 22.9019L11.9946 20.1521L18.0388 22.9022C18.7856 23.2419 19.6043 22.5968 19.4488 21.7914L18.2035 15.3428L22.738 10.1951C23.2715 9.58953 22.9143 8.63379 22.1144 8.52648L15.853 7.68653L12.9037 1.58354Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M17.352 2.36598C16.8019 1.22774 15.1804 1.22897 14.632 2.36789L10.8564 10.2088L2.81893 11.287C1.62394 11.4473 1.08942 12.8746 1.88546 13.7804L7.70668 20.4042L6.11849 28.6989C5.88797 29.9028 7.11233 30.8653 8.22782 30.3569L15.993 26.8175L23.7728 30.3573C24.8892 30.8653 26.1133 29.9007 25.8807 28.6965L24.2794 20.4041L30.1131 13.7817C30.9106 12.8763 30.3766 11.4474 29.1807 11.287L21.142 10.2086L17.352 2.36598Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;